// extracted by mini-css-extract-plugin
export default {"showcase":"Showcase_showcase__qGM74","showcaseContainer":"Showcase_showcaseContainer__TuOXx"};